import { TextThreadEditorVMConfig } from 'components/editors/thread/text/textThread';
import { ActivityFormConfig } from './form.common';

const activityFormsInfoSets: Array<ActivityFormConfig> = [
    {
        views: {
            classic: 'info-thread-editor'
        },

        isActive: ({ topic }) => topic.isInformationOnlyTopic()
    },

    {
        views: {
            classic: 'survey-editor-standalone',
            mobile: 'survey-editor-mobile'
        },

        isActive: ({ topic, user, thread, canAddComment }) => topic.isSurvey() && (user.isRegular() && canAddComment || thread != undefined)
    },

    {
        views: {
            classic: 'externalsurvey-editor-participant'
        },

        isActive: ({ topic, user }) => topic.isExternalSurvey() && user.isRegular()
    },

    {
        views: {
            classic: 'externalsurvey-editor-mod'
        },

        isActive: ({ topic, user }) => topic.isExternalSurvey() && user.isModeratorOrObserver()
    },

    {
        views: {
            classic: 'heatmap-editor-standalone',
            mobile: 'heatmap-editor-mobile'
        },

        isActive: ({ topic, user, canAddComment }) => topic.isHeatMap() && user.isRegular() && canAddComment
    },

    {
        views: {
            classic: 'cards-sort-editor-standalone',
            mobile: 'cards-sort-editor-mobile'
        },

        isActive: ({ topic, user, thread, canAddComment }) => topic.isCardSort() && (user.isRegular() && canAddComment || thread != undefined)
    },

    {
        views: {
            'classic': 'cards-score-editor-standalone',
            'mobile': 'cards-score-editor-mobile'
        },

        isActive: ({ topic, user, thread, canAddComment }) => topic.isCardScore() && (user.isRegular() && canAddComment || thread != undefined)
    },

    {
        views: {
            'classic': 'video-presentation-editor-standalone',
            'mobile': 'video-presentation-editor-mobile'
        },

        isActive: ({ topic, user, thread, canAddComment }) => topic.isVideoPresentation() && (user.isRegular() && canAddComment || thread != undefined)
    },

    {
        views: {
            'classic': 'pinboard-editor-standalone',
            'mobile': 'pinboard-editor-mobile'
        },

        isActive: ({ topic, user, thread, canAddComment }) => topic.isPinBoard() && (user.isRegular() && canAddComment || thread != undefined)
    },

    {
        views: {
            'classic': 'multicomment-editor-standalone',
            'mobile': 'multicomment-editor-mobile'
        },

        isActive: ({ topic, user, canAddComment }) => topic.isMultipleComments() && (user.isRegular() && canAddComment)
    },

    {
        views: {
            'classic': 'screenrecording-editor-standalone',
            'mobile': 'screenrecording-editor-mobile'
        },

        isActive: ({ topic, user, canAddComment }) => topic.isScreenRecording() && (user.isRegular() && canAddComment)
    },

    {
        views: {
            'classic': 'audiorecording-editor-standalone',
            'mobile': 'audiorecording-editor-mobile'
        },

        isActive: ({ topic, user, canAddComment }) => topic.isAudioRecording() && (user.isRegular() && canAddComment)
    },    

    {
        views: {
            classic: ['comment-editor-standalone', <TextThreadEditorVMConfig>{ focus: true, title: true }],
            mobile: ['comment-editor-mobile', <TextThreadEditorVMConfig>{ focus: true, title: true }]
        },

        isActive: ({ topic, user, canAddComment }) => topic.isIdeation() && topic.ideationStage() == enums.IdeationStages.IdeaCreation.value && (user.isRegular() && canAddComment)
    },

    {
        views: {
            classic: ['comment-editor-standalone', <TextThreadEditorVMConfig>{ focus: true }],
            mobile: ['comment-editor-mobile', <TextThreadEditorVMConfig>{ focus: true }]
        },

        isActive: ({ task, topic, user, canAddComment }) => {
            return (!user.isRegular() && !topic.isIdeation() || topic.isTextCommentsTopic() || topic.isMediaOnly() || topic.isDocumentsCollection() || topic.isVoxPop()) &&
                (!user.isObserver() || task.observerCanPostComments()) &&
                canAddComment;
        }
    }
]

export default activityFormsInfoSets;